const processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./accountLeftNavigation/accountLeftNavigation'));
});